<div class="cyc-progress-bar__wrapper">
  <div class="w-full">
    <div class="cyc-progress-bar__info">
      <div>
        <span class="inline-block pb-1 pr-2">
          <ng-content></ng-content>
        </span>
      </div>
      <span
        class="font-semibold inline-block text-primary-dark"
        data-test-id="progress-bar-value"
      >
        @if (showPercentage()) {
          {{ value() | number: '1.0-0' }}%
        }
      </span>
    </div>
    <div class="cyc-progress-bar__bar-outer">
      <div
        [style.width.%]="value()"
        class="cyc-progress-bar__bar-inner"
      ></div>
    </div>
  </div>
</div>
